
import React, { useEffect } from "react";
import Router from "next/router";
import { LOGIN, MY_PROFILE } from "../utils/contants/routers";


export default function HomePage() {

  useEffect(() => {
    if (getAuth())
      Router.push(MY_PROFILE);
    else
      Router.push(LOGIN);
  }, []);

  const getAuth = () => {
    const authenticated = localStorage.getItem("Authorization");
    return authenticated;
  };

  return null;
};
